export enum MessageDirection {
  Incoming = 'incoming',
  Outgoing = 'outgoing',
}
